import React, {useCallback, useId, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Checkbox, Popup} from '@tickchak/react-share/app';
import * as css from './LoaderPopupAI.css';
import TypewriterIllustration from './TypewriterIllustration';
import type {TShow} from '../../hooks/useShow';
import {updateUserPreferences} from '../../redux/user/userActions';
import {loaderPopupDismissRef} from './dismissLoaderPopupAI';

interface LoaderPopupAIProps {
    show: TShow;
}

function LoaderPopupAI({show}: LoaderPopupAIProps) {
    const {t} = useTranslation('whatsapp');
    const titleId = useId();
    const bodyId = useId();
    const [doNotShowAgain, setDoNotShowAgain] = useState(false);

    const dismissPopup = useCallback(() => {
        if(doNotShowAgain) {
            updateUserPreferences({hideWhatsappFreeLoader: true}).then();
        }
        show.close();
    }, [show, doNotShowAgain]);

    loaderPopupDismissRef.current = dismissPopup;

    return (
        <Popup show={show} data-cy="loaderPopupAi">
            <css.content
                aria-labelledby={titleId}
                aria-describedby={bodyId}
            >
                <TypewriterIllustration />
                <css.title id={titleId}>{t('aiSaveLoader.title')}</css.title>
                <css.body id={bodyId}>{t('aiSaveLoader.body')}</css.body>
                <Button
                    variant="brand"
                    size="category"
                    onClick={dismissPopup}
                    customStyle={{width: '100%', borderRadius: '100px', minHeight: '44px'}}
                >
                    {t('aiSaveLoader.thanks')}
                </Button>
                <css.footerRow>
                    <Checkbox
                        shape='square'
                        checked={doNotShowAgain}
                        onChange={e => setDoNotShowAgain(e.target.checked)}
                    />
                    <css.checkboxLabel>{t('aiSaveLoader.skipNextTime')}</css.checkboxLabel>
                </css.footerRow>
            </css.content>
        </Popup>
    );
}

export default LoaderPopupAI;
